<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <div id="ww_login"></div>
  </div>
</template>

<script>
import * as qywxSdk from '@wecom/jssdk'
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import { getUserInfo } from "@/api/qywx"

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  },
  mounted() {
    this.registerSdk();
  },
  methods: {
    registerSdk() {
      // qywxSdk.register({
      //   corpId: 'ww7ca4776b2a70000',
      //   jsApiList: ['getExternalContact'],
      //   getConfigSignature: this.registerSdk,
      //   onConfigSuccess: (checkResult, errMsg, errCode) => {
      //     alert(checkResult, errMsg, errCode)
      //   },
      //   onConfigFail: (errMsg, errCode) => {
      //     alert(errMsg, errCode)
      //   }
      // })

      let _self = this;
      qywxSdk.createWWLoginPanel({
        el: '#ww_login',
        params: {
          login_type: 'CorpApp',
          appid: 'ww78051a0b07bfdbf6',
          agentid: '1000003',
          redirect_uri: 'https://mxqih.top/test',
          state: 'loginState',
          redirect_type: 'callback',
        },
        onCheckWeComLogin({ isWeComLogin }) {
          console.log(isWeComLogin)
        },
        onLoginSuccess({ code }) {
          console.log({ code })
          _self.getUserInfo(code);
        },
        onLoginFail(err) {
          console.log(err)
        },
      })
    },

    async getConfigSignature(url) {
      return { timestamp, nonceStr, signature }
    },

    getUserInfo(code) {
      console.log("获取用户信息")
      getUserInfo({code}).then(res => {
        console.log(res)
      })
    }
  }
}
</script>
